import React from 'react';

import OptionText from './OptionText';

import styles from './styles.module.scss'

interface IOptionsSelector {
  allOptions: string[];
  selectedOption: string;
  setSelectedOption: (selectedOption: string) => void;
}

export default function OptionsSelector({allOptions, selectedOption, setSelectedOption}: IOptionsSelector) {
  const onClick = (option: string) => {
    setSelectedOption(option)
  }
  
  const renderOptions = () => {
    return allOptions.map(option => {
      return (
        <OptionText 
          key={option}
          text={option}
          selected={option === selectedOption}
          onClick={onClick}
        />
      )
    })
  }
  
  return (
    <div className={styles.optionsSelector}>
      { renderOptions() }
    </div>
  )
};
